// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3108":"acf97582","4128":"6a8b0046","4944":"acf97582","7602":"47ccc9ac","7779":"379b85ae","7828":"1f38fb17","8061":"69bfc392","9789":"2da8f8ea"}[chunkId] + ".chunk.css";
};